import CountriesListPageReducer from './CountriesListPageReducer';

export default from './CountriesListPageContainer';
export const CountriesListPageReducers = {
  CountriesListPageReducer,
};
